import errorCodes from 'srcAlias/client/enums/errorCodes';
import { store } from 'srcAlias/initialization';
import { get } from 'lodash-es';

export const INIT_EVENT = 'INIT_EVENT';
export const PIGGYBANK_EVENT = 'PIGGYBANK_EVENT';
export const ERROR_EVENT = 'ERROR_EVENT';
export const TRACK_EVENT = 'TRACK_EVENT';

export const initEvent = () => ({
  type: INIT_EVENT,
});

export const piggybankEvent = (event) => {
  const reduxState = store.getState();
  return {
    type: PIGGYBANK_EVENT,
    event: {
      ...event,
      state: {
        application: {
          applicationId: get(
            reduxState,
            'eligibility.responseData.data.applicationId',
            ''
          ),
        },
        accountType: get(
          reduxState,
          'updateSelectedAccountReducer.selectedProducts[0].productCodeDescription',
          ''
        ),
        productSelection: get(reduxState, 'productSelection', ''),
        sessionId: get(reduxState, 'sessionId', ''),
      },
    },
  };
};

export const errorEvent = (event = {}) => ({
  type: ERROR_EVENT,
  event: {
    category: errorCodes.CLIENT_GENERIC,
    ...event,
  },
});

export const trackEvent = (keyPath, rest = {}) => ({
  type: TRACK_EVENT,
  event: {
    keyPath,
    ...rest,
  },
});
